<script setup lang="ts">
import { RouteLocationNamedRaw, RouteLocationPathRaw } from 'vue-router'

interface IProps {
  url: string | RouteLocationPathRaw | RouteLocationNamedRaw
  routeBackPossible?: boolean
}

const props = defineProps<IProps>()

const router = useRouter()
const routeBack = () => {
  if (props.routeBackPossible && isPossibleRouteBack()) {
    router.back()
  } else {
    router.push(props.url)
  }
}

const isPossibleRouteBack = () => {
  return window?.history?.state.back !== null
}
</script>

<template>
  <button
    class="back-button-container"
    @click="routeBack"
  >
    <span class="icon-cont">
      <FontAwesomeIcon icon="chevron-left" />
    </span>
  </button>
</template>

<style scoped lang="scss">
.back-button-container {
  @apply flex justify-start gap-x-2 text-primary items-center font-bold outline-none hover:bg-primary/5 p-2 rounded-lg hover:text-primary transition-all duration-300 ease-[ease];
  .icon-cont {
    @apply w-6 inline-flex justify-center items-center;
  }
}
</style>